export default __webpack_public_path__ + "static/yoga-pose-correction-ai-computer-vision-bd9a64019daef30d2b5a83b67db21a4a.jpeg";